import React from "react";

import { connect } from "../i18n/connect";
import { verifyOtpHashRoutine } from "../redux/modules/auth/register";
import { getOtpVerifyLoading } from "../redux/modules/auth/register/selector";

export default function withLoginOtpHash(WrappedComponent) {
  const mapStateToProps = state => ({
    verifyLoading: getOtpVerifyLoading(state)
  });

  const mapDispatchToProps = {
    verifyOtpHash: verifyOtpHashRoutine.trigger
  };

  @connect(mapStateToProps, mapDispatchToProps)
  class WithLoginOtpHash extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithLoginOtpHash;
}
